import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { addParamsToUrl } from 'utils/query';
import { providesList, cacheByIdArg } from 'utils/query-cache';

import { apiQuery } from '../../query';

import { Inventory, InventoryRequest, InventoryDetailsRequest } from './types';

export const tagType = 'inventory';

export const inventoryApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiQuery,
  reducerPath: 'inventoryApi',
  endpoints: (build) => ({
    list: build.query<Inventory[], InventoryRequest>({
      providesTags: providesList(tagType),
      query: ({ id, ...params }) => ({
        method: 'get',
        url: addParamsToUrl(URL.STORAGE_INVENTORY.replace(':id', id), params),
      }),
    }),

    details: build.query<Inventory, InventoryDetailsRequest>({
      providesTags: (result, error, arg) =>
        cacheByIdArg(tagType)(result, error, arg.inventoryId),
      query: ({ id, inventoryId }) => ({
        method: 'get',
        url: URL.STORAGE_INVENTORY_DETAILS.replace(':id', id).replace(
          ':inventoryId',
          inventoryId
        ),
      }),
    }),
  }),
});

export const { useListQuery, useDetailsQuery } = inventoryApi;

export type { Inventory };
